export const SKIP_AUTH_HEADER = 'X-SkipAuthHeader';
export const AUTH_HEADER = 'Authorization';
